import { Component, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { MapInfoWindow, MapMarker, GoogleMap } from '@angular/google-maps'
import { StateService } from '../../services/state.service';

@Component({
  selector: 'app-google-map',
  templateUrl: './google-map.component.html',
  styleUrls: ['./google-map.component.css']
})
export class GoogleMapComponent implements OnInit {

  @ViewChild(GoogleMap, { static: false }) map: GoogleMap;
  //@ViewChild(MapInfoWindow, { static: false }) info: MapInfoWindow;
  @ViewChildren(MapMarker) mrkr: QueryList<MapMarker>;
  @ViewChildren(MapInfoWindow) info: QueryList<MapInfoWindow>;
  
  mapCenter: google.maps.LatLngLiteral
  
  mapOptions = {
	zoom: 12
  }
  
  screenHeight = window.innerHeight;
  markers = [];
  infoContent = '';
  vehicles:any = [];
  openedInfoWdws = [];
  bounds:any = {};
  
  constructor(private stateSvc: StateService) { }

  ngOnInit(): void {
	this.mapCenter = {
		lat: 3.129958,
		lng: 101.67509
	};
	this.stateSvc.windowHeight.subscribe((result) => {
		this.screenHeight = result;
	});
	this.stateSvc.vehicles
	.subscribe((result) => {
		let vhcls = result;
		this.vehicles = vhcls;
		this.markers = [];
		vhcls?.forEach((vhcl) => {
			if(vhcl.shownOnMap){
				this.markers.push({
				  position: vhcl.markerPosition,
				  title: 'Marker '+vhcl.unitid,
				  info: vhcl.infowWindowContent,
				  markerOptions: vhcl.markerOptions
				});
				/*this.bounds.extend(new google.maps.LatLng(vhcl.markerPosition.lat, vhcl.markerPosition.lng));
				console.log('boundupdate',this.bounds);console.log('vhcl.markerPosition',vhcl.markerPosition);
				if(this.map && this.bounds){console.log('boundnew',this.bounds);
					this.map.fitBounds(this.bounds);
					setTimeout(function() {
						if(this.map.getZoom() > 14) {
							this.map.setZoom(14)
						}
					}, 500);
				}*/
			}
		});
	});
	this.stateSvc.tripMarkers
	.subscribe((mkrs:any) => {
		if(mkrs.length > 0){
			let tempVehicleMarker = this.markers[0];
			this.markers = [];
			tempVehicleMarker.position = mkrs[0].position;console.log(tempVehicleMarker);
			this.markers.push(tempVehicleMarker);
			this.markers.forEach((exMkr, index) => {
				if(exMkr.markerOptions?.type == 'trip'){
					this.markers.splice(index, 1);
				}
			});
			mkrs.forEach((mkr) => {
				this.markers.push({
				  position: mkr.position,
				  title: mkr.title,
				  info: mkr.info,
				  markerOptions: mkr.markerOptions
				})
			});
		}
	});
	this.stateSvc.newInfoWindowToOpen
	.subscribe((vhcl:any) => {
		if(vhcl.unitid){
			this.openInfo(this.mrkr.toArray()[0],vhcl.infowWindowContent);
		}
		setTimeout(() => {
			this.bounds = new google.maps.LatLngBounds();console.log(this.bounds);
			console.log('bound',this.map.getBounds());
		}, 1500);
	});
	setTimeout(() => {
		this.stateSvc.setMapInstance(this.map);
	},2000);
  }
  
  openInfo(marker: MapMarker, content) {
	this.infoContent = content
	let rawTitle = marker.getTitle();
	let splittedTitle = rawTitle.split(' ');
	let nwTtl = parseInt(splittedTitle[1]);
	this.closeInfoWdw();
	this.info.toArray()[0].open(marker);
	this.openedInfoWdws = [nwTtl];
  }
  
  closeInfoWdw(){
	this.vehicles.forEach((vhcl) => {
		if(this.openedInfoWdws[0] == vhcl.unitid){
			this.stateSvc.setOldInfoWindowToClose(vhcl);
		}
	});
  }

}
